import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { CircularProgress } from '@mui/material';
import pallet from '../../layouts/pallet';
import { UsersTableContainer, LoadingOverlay } from './styled';
import { UserTableProps } from './types';
import { schoolOfficeUserColumns } from './utils/utils';
import { dataGridSx } from '../common/styled/DataGrid';
import tableColumnUtils from '../../utils/tableColumnUtils';

const SchoolOfficeUsersTable: React.FC<UserTableProps> = ({
  users,
  onEdit,
  loading
}) => {
  const columns = schoolOfficeUserColumns(onEdit);
  const rows = users.map((user) => ({ ...user, id: user.id }));

  return (
    <UsersTableContainer>
      <DataGrid
        rows={rows}
        columns={columns}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        sx={dataGridSx(pallet)}
        loading={loading}
      />
      {loading && (
        <LoadingOverlay>
          <CircularProgress />
        </LoadingOverlay>
      )}
    </UsersTableContainer>
  );
};

export default SchoolOfficeUsersTable;
